import Keycloak from 'keycloak-js'
import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { KeycloakAuth } from './auth'
import { appConfig } from './config'

//used realm is the used subdomain (e.g. in https://client1.nium.io, client1 will be used as the realm)
const keycloakConfig = {
  realm: appConfig.keycloak.realm,
  clientId: appConfig.keycloak.clientId,
  url: appConfig.keycloak.url,
  multiTenancyEnabled: appConfig.keycloak.multiTenancyEnabled,
}
const subdomain = window.location.hostname.split('.')[0]

if (subdomain !== 'localhost' && keycloakConfig.multiTenancyEnabled) {
  keycloakConfig.realm = subdomain
}

const keycloak = new Keycloak(keycloakConfig)

keycloak
  .init({ onLoad: 'login-required', checkLoginIframe: false })
  .then((authenticated) => {
    if (authenticated) {
      KeycloakAuth.setKeycloak(keycloak)

      const root = createRoot(document.getElementById('root')!)
      root.render(
        <StrictMode>
          <App />
        </StrictMode>,
      )
    } else {
      console.error('Authentication failed!')
    }
  })
  .catch((error) => console.error('Authentication failed! ', error))
